export const getSingleByteCharactersNumberOfCharacters = (str: string) => {
  const codePoint = 128
  let strLength = 0
  let i = 0
  for(i; i < str.length; i++) {
    strLength += (str.codePointAt(i) || 0) < codePoint ? 1 : 2
  }
  return strLength
}